function initStickyCart() {
  // Tear down a previous instance (the theme editor re-renders the section; see the section events below).
  if (typeof window.__stickyCartDestroy === 'function') window.__stickyCartDestroy();

  var anchor = document.querySelector('[data-sticky-cart-anchor]');
  if (!anchor) return;
  var original = anchor.querySelector('.product-form__submit');
  if (!original) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var bar = document.createElement('div');
  bar.className = 'sticky-cart-bar';
  var clone = document.createElement('button');
  clone.type = 'button';
  bar.appendChild(clone);
  document.body.appendChild(bar);

  var lifted = [];

  // The bar does not add to cart: it takes the customer back to the variant picker so the variant is chosen
  // explicitly. Products without variants have no picker, so fall back to the original button.
  var section = anchor.closest('.shopify-section') || document;
  var target = section.querySelector('variant-radios, variant-selects') || anchor;

  // Same look as the original button, fixed label.
  clone.className = original.className;
  clone.textContent = anchor.getAttribute('data-sticky-cart-label') || original.textContent.trim();

  function onClick() {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  clone.addEventListener('click', onClick);

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, LINK: 1, SVG: 1, svg: 1, IFRAME: 1, TEMPLATE: 1, NOSCRIPT: 1 };

  function isLifted(el) {
    return lifted.some(function (item) {
      return item.el === el;
    });
  }

  // Floating widgets are often nested (Wishlist Hero) or inside an open shadow root (Channel Talk),
  // so walk descendants instead of checking only body's direct children.
  function findFloating(root, h, depth, found) {
    Array.prototype.forEach.call(root.children, function (el) {
      if (el === bar || SKIP_TAGS[el.tagName]) return;
      var cs = getComputedStyle(el);
      if (cs.display === 'none') return;
      if (cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        // only small floating widgets near the bottom edge; a fixed element's descendants move with it
        if (r.width > 0 && r.height > 0 && r.height <= 160 && r.width <= 160 && window.innerHeight - r.bottom <= h + 40) {
          found.push(el);
        }
        return;
      }
      if (depth >= 8) return;
      findFloating(el, h, depth + 1, found);
      if (el.shadowRoot) findFloating(el.shadowRoot, h, depth + 1, found);
    });
    return found;
  }

  // Icons moving back down keep the lift transition until it ends, then get their own transition back.
  var settling = [];

  function restoreTransition(item) {
    clearTimeout(item.timer);
    item.el.style.setProperty('transition', item.transition, item.transitionPriority);
  }

  // Inline style is used because page CSS does not reach elements inside a shadow root.
  function liftIcons() {
    var h = bar.offsetHeight;
    document.documentElement.style.setProperty('--sticky-cart-height', h + 'px');
    findFloating(document.body, h, 0, []).forEach(function (el) {
      if (isLifted(el)) return;
      var item = null;
      settling = settling.filter(function (s) {
        if (s.el !== el) return true;
        // lifted again before settling: keep the original inline values saved earlier
        clearTimeout(s.timer);
        item = s;
        return false;
      });
      if (!item) {
        item = {
          el: el,
          transform: el.style.getPropertyValue('transform'),
          transformPriority: el.style.getPropertyPriority('transform'),
          transition: el.style.getPropertyValue('transition'),
          transitionPriority: el.style.getPropertyPriority('transition')
        };
      }
      lifted.push(item);
      el.style.setProperty('transition', 'transform 0.2s ease', 'important');
      el.style.setProperty('transform', 'translateY(-' + h + 'px)', 'important');
    });
  }

  function restoreIcons(immediate) {
    lifted.forEach(function (item) {
      item.el.style.setProperty('transform', item.transform, item.transformPriority);
      if (immediate) {
        restoreTransition(item);
        return;
      }
      settling.push(item);
      item.timer = setTimeout(function () {
        settling = settling.filter(function (s) {
          return s !== item;
        });
        restoreTransition(item);
      }, 250);
    });
    lifted = [];
    if (immediate) {
      settling.forEach(restoreTransition);
      settling = [];
    }
  }

  function set(active) {
    if (active === bar.classList.contains('is-visible')) return;
    bar.classList.toggle('is-visible', active);
    // body padding keeps the footer's last line clear of the bar
    document.body.classList.toggle('has-sticky-cart', active);
    if (active) {
      liftIcons();
    } else {
      restoreIcons();
    }
  }

  // Show the bar only once the original button has scrolled out above the viewport.
  function update() {
    var past = original.getBoundingClientRect().bottom < 0;
    set(mq.matches && past);
  }

  // capture: scroll may happen on html/body or another container, which never reaches window in bubble phase
  window.addEventListener('scroll', update, { capture: true, passive: true });
  window.addEventListener('touchmove', update, { passive: true });
  window.addEventListener('resize', update);
  // Periodic check also lifts widgets that appear after the bar is shown (chat, LINE popup load late).
  var timer = setInterval(function () {
    update();
    if (bar.classList.contains('is-visible')) liftIcons();
  }, 300);
  // MediaQueryList.addEventListener is missing on iOS Safari 13 and older
  if (mq.addEventListener) {
    mq.addEventListener('change', update);
  } else if (mq.addListener) {
    mq.addListener(update);
  }

  window.__stickyCartDestroy = function () {
    clearInterval(timer);
    window.removeEventListener('scroll', update, { capture: true });
    window.removeEventListener('touchmove', update);
    window.removeEventListener('resize', update);
    if (mq.removeEventListener) {
      mq.removeEventListener('change', update);
    } else if (mq.removeListener) {
      mq.removeListener(update);
    }
    clone.removeEventListener('click', onClick);
    restoreIcons(true);
    document.body.classList.remove('has-sticky-cart');
    if (bar.parentNode) bar.parentNode.removeChild(bar);
    window.__stickyCartDestroy = null;
  };

  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyCart);
} else {
  initStickyCart();
}

// The theme editor swaps section HTML without re-running scripts inside it, so re-initialise on its section events.
// Registered once even if this file is loaded by more than one section.
if (!window.__stickyCartEditorEvents) {
  window.__stickyCartEditorEvents = true;
  document.addEventListener('shopify:section:unload', function (event) {
    if (typeof window.__stickyCartDestroy !== 'function') return;
    if (event.target.querySelector('[data-sticky-cart-anchor]')) window.__stickyCartDestroy();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-sticky-cart-anchor]')) initStickyCart();
  });
}
